import {
  ReportingTableApiResponse,
  ReportingActivityApiResponse,
} from './types';

export type State = {
  table: ReportingTableApiResponse;
  activity: ReportingActivityApiResponse;
};

export const state: State = {
  table: {} as ReportingTableApiResponse,
  activity: {} as ReportingActivityApiResponse,
};
